import React, { useState } from "react";
import PropTypes from "prop-types";
import { AsyncPaginate } from "react-select-async-paginate";

import qahoy from "views_shared/app/javascript/scripts/qahoy";
import qapi from "views_shared/app/javascript/api";
import ImageCropped from "views_shared/app/javascript/components/ImageCropped";

const isOptionSelected = (option, values) => {
  return values.some(({ value }) => option.value === value);
};

const formatPersonOptionInSelect = (person) => (
  <>
    <ImageCropped roundedCircle src={person.image_url} alt={person.name} size={45} fallbackToInitials />
    <span className="ms-3 fw-bold">{person.label}</span>{" "}
    <span className="text-secondary"> | {person.workplace_name}</span>
  </>
);

const formatSelectOptionsFromProfilesResponse = (profiles) => {
  return profiles?.map((rep) => {
    return {
      value: rep.id,
      label: rep.name,
      workplace_name: rep.workplace_name,
      image_url: rep.profile_image_url,
    };
  });
};

function PrRepresentativeSelect({
  value,
  isMulti,
  excludeIds = [],
  onChange = () => {},
  onAsyncError = () => {},
  placeholder = "Type to search…",
  inputId,
}) {
  const [allRepresentativeOptions, setAllRepresentativeOptions] = useState();

  const loadOptions = async (searchString, loadedOptions, { page }) => {
    const fieldsToSearch = ["name", "bio", "workplace_name"];
    let options = [];
    let result = { options: [], hasMore: false };

    try {
      qahoy.track("PrRepresentativeSelect#loadOptions", {
        searchString,
        fieldsToSearch,
      });

      const response = await qapi.prProfiles.getAllFullTextSearch(searchString, fieldsToSearch, { page });

      if (!response.data) return result;
      options = formatSelectOptionsFromProfilesResponse(response.data);

      result = {
        options,
        hasMore: response.remainingRows > 0,
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      onAsyncError(error);
      return { options: [], hasMore: false };
    }

    if (!searchString && allRepresentativeOptions === undefined) {
      setAllRepresentativeOptions(options);
    }

    return result;
  };

  return (
    <div>
      <AsyncPaginate
        // cacheOptions
        inputId={inputId}
        loadOptions={loadOptions}
        debounceTimeout={300}
        placeholder={placeholder}
        formatOptionLabel={formatPersonOptionInSelect}
        value={value}
        isOptionSelect={isOptionSelected}
        onChange={(option) => {
          onChange(option);
        }}
        defaultOptions
        filterOption={(option) => !excludeIds.includes(option?.value)}
        isClearable
        isMulti={isMulti}
        additional={{
          page: 1,
        }}
      />
    </div>
  );
}

PrRepresentativeSelect.propTypes = {
  isMulti: PropTypes.bool.isRequired,
  excludeIds: PropTypes.arrayOf(PropTypes.number),
  onChange: PropTypes.func,
  onAsyncError: PropTypes.func,
  placeholder: PropTypes.string,
  inputId: PropTypes.string,
};

export default PrRepresentativeSelect;
